<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.vigencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="month" v-model="vigencia" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.activoCorriente}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="activoCorriente" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.activoNoCorriente}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="activoNoCorriente" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.totalActivo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="totalActivo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.pasivoCorriente}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="pasivoCorriente" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.pasivoNoCorriente}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="pasivoNoCorriente" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.totalPasivo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="totalPasivo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.utilidadAcumulada}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="utilidadAcumulada" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.totalPatrimonio}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="totalPatrimonio" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.ebit}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="ebit" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarZscore">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import InformacionFinanciera from '../../../services/InformacionFinanciera'

export default {
    name : 'Crear',
    props : ['modalCrear'],
    data: () => ({
        vigencia : '',
        activoCorriente : '',
        activoNoCorriente : '',
        totalActivo : '',
        pasivoCorriente : '',
        pasivoNoCorriente : '',
        totalPasivo : '',
        utilidadAcumulada : '',
        totalPatrimonio : '',
        ebit : '',
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Crear información financiera',
                    save : 'Guardar',
                    close : 'Cerrar',
                    vigencia : 'Vigencia',
                    activoCorriente : 'Activo corriente',
                    activoNoCorriente : 'Activo no corriente',
                    totalActivo : 'Total activo',
                    pasivoCorriente : 'Pasivo corriente',
                    pasivoNoCorriente : 'Pasivo no corriente',
                    totalPasivo : 'Total pasivo',
                    utilidadAcumulada : 'Utilidad acumulada',
                    totalPatrimonio : 'Total patrimonio',
                    ebit : 'EBIT',
                }
            }else{
                return {
                    title : 'Create financial information',
                    save : 'Save',
                    close : 'Close',
                    vigencia : 'Validity',
                    activoCorriente : 'Current assets',
                    activoNoCorriente : 'Non-current asset',
                    totalActivo : 'Total assets',
                    pasivoCorriente : 'Passive current',
                    pasivoNoCorriente : 'Passive Non-Current',
                    totalPasivo : 'Total liabilities',
                    utilidadAcumulada : 'Accumulated profit',
                    totalPatrimonio : 'Total Assets',
                    ebit : 'EBIT',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarZscore(){
            const dataForm = [
                this.vigencia,
                this.activoCorriente,
                this.activoNoCorriente,
                this.totalActivo,
                this.pasivoCorriente,
                this.pasivoNoCorriente,
                this.totalPasivo,
                this.utilidadAcumulada,
                this.totalPatrimonio,
                this.ebit,
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            
            }else{

                let info = {
                    'vigencia' : this.vigencia,
                    'activoCorriente' : this.activoCorriente,
                    'activoNoCorriente' : this.activoNoCorriente,
                    'totalActivo' : this.totalActivo,
                    'pasivoCorriente' : this.pasivoCorriente,
                    'pasivoNoCorriente' : this.pasivoNoCorriente,
                    'totalPasivo' : this.totalPasivo,
                    'utilidadAcumulada' : this.utilidadAcumulada,
                    'totalPatrimonio' : this.totalPatrimonio,
                    'ebit' : this.ebit,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);

                InformacionFinanciera.createInformacionFinaciera(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    }
                })
                .catch((err) => console.log(err))
            }
        },

    }
}
</script>

<style>

</style>